import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { GemstoneTypeWithShape } from 'src/app/interfaces/gemstone-type-with-shape';

@Injectable({
  providedIn: 'root'
})
export class StoneTypesWithShapesProviderService extends APIProviderService<GemstoneTypeWithShape> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Gemstones/TypesWithShapes`;
  }
}
